import { useTranslation } from 'react-i18next';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import AffiliateIcon from 'components/icons/AffiliateIcon';
import { IntegrationEnum } from 'models/InternalIntegrationSetting';
import { PropertyMetadata } from 'models/Properties';
import { orderBy } from 'utils/arrayUtils';
import { typedEntries } from 'utils/funcs';
import {
  DYNAMIC_PRICING_TOOLS,
  DYNAMIC_PRICING_TOOLS_PRIORITY_ORDER,
} from './PricingUpdates.constants';

interface PricingUpdatesDynamicToolProps {
  enabledPricingTools: IntegrationEnum[];
  pricingMetadata: PropertyMetadata['pricingMetadata'] | undefined;
}

const PricingUpdatesDynamicTool = ({
  enabledPricingTools,
  pricingMetadata,
}: PricingUpdatesDynamicToolProps) => {
  const { t } = useTranslation();
  const activePricingTools = typedEntries(DYNAMIC_PRICING_TOOLS).filter(
    ([enumId]) => enabledPricingTools.includes(enumId),
  );
  const sortedPricingTools = orderBy(activePricingTools, [
    {
      field: ([key]) => DYNAMIC_PRICING_TOOLS_PRIORITY_ORDER.indexOf(key),
      order: 'asc',
    },
  ]);

  const [enumId, dynamicPricingTool] = sortedPricingTools[0] ?? [];

  if (!dynamicPricingTool || !enumId) {
    return null;
  }

  return (
    <div className="pricing-tool-updates" data-testid="pricing-tool-updates">
      <span>
        {t('pageCalendar.standalone.pricingUpdates.dynamicPricingOn')}{' '}
        <a
          className="pricing-tool-link"
          href={dynamicPricingTool.url}
          target="_blank"
          rel="noreferrer"
        >
          <AffiliateIcon affiliate={enumId} data-testid={`icon-${enumId}`} />
          {dynamicPricingTool.name}
        </a>
      </span>
      {pricingMetadata?.pricingToolMostRecentUpdateDate && (
        <DropdownButton
          bsStyle="default"
          id="pricing-tool-updates"
          title={t('pageCalendar.standalone.pricingUpdates.lastUpdateFrom', {
            value: dynamicPricingTool.name,
          })}
        >
          <MenuItem>
            <AffiliateIcon affiliate={enumId} />
            {t('common.dateTimeLongWithoutWeekDay', {
              date: pricingMetadata.pricingToolMostRecentUpdateDate,
            })}
          </MenuItem>
        </DropdownButton>
      )}
    </div>
  );
};

export default PricingUpdatesDynamicTool;
